import React from "react";
import { Link } from "react-router-dom";
import { Logo, Monogram, TAGLINE, SIGNATURE_QUESTION } from "@/marketing/brand";

const PANEL_IMG = "https://images.pexels.com/photos/7318938/pexels-photo-7318938.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1300&w=1000";

/* Google G logo (official 4-color) */
export const GoogleButton = ({ onClick, label = "Continue with Google", testid = "google-signin-button" }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className="id-sans flex w-full items-center justify-center gap-3 rounded-full border border-[var(--id-charcoal)]/20 bg-white px-6 py-3 text-[14px] font-medium text-[var(--id-charcoal)] transition-colors hover:bg-[var(--id-charcoal)]/[0.04]">
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    </svg>
    {label}
  </button>
);

/* Split brand auth layout used by Sign in / Create account. */
export const AuthShell = ({ title, subtitle, children, footer }) => (
  <div className="id-surface min-h-screen grid lg:grid-cols-[1.05fr_1fr]">
    {/* Editorial panel */}
    <div className="relative hidden lg:block bg-[var(--id-charcoal)]">
      <img src={PANEL_IMG} alt="" className="absolute inset-0 h-full w-full object-cover opacity-70" />
      <div className="absolute inset-0" style={{ background: "linear-gradient(155deg, rgba(32,32,32,0.35), rgba(75,59,49,0.85))" }} />
      <div className="relative flex h-full flex-col justify-between p-12">
        <div className="flex items-center gap-3">
          <Monogram className="h-12" />
          <span className="id-serif text-2xl tracking-[0.16em] text-[var(--id-ivory)]">INTRINSIC DAILY</span>
        </div>
        <div>
          <p className="id-serif text-[clamp(2rem,3vw,2.8rem)] italic leading-[1.15] text-[var(--id-ivory)]">“{SIGNATURE_QUESTION}”</p>
          <p className="id-sans mt-6 max-w-sm text-[15px] text-[var(--id-ivory)]/75">{TAGLINE}</p>
        </div>
        <Link to="/" className="id-sans text-sm text-[var(--id-ivory)]/70 hover:text-[var(--id-ivory)]">← Back to home</Link>
      </div>
    </div>

    {/* Form panel */}
    <div className="flex items-center justify-center px-6 py-14">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-block lg:hidden mb-8"><Logo className="h-9" /></Link>
        <h1 className="id-serif text-[clamp(2.2rem,5vw,3rem)] leading-[1.05] text-[var(--id-charcoal)]">{title}</h1>
        {subtitle && <p className="id-sans mt-3 text-[15px] text-[var(--id-charcoal)]/65">{subtitle}</p>}
        <div className="mt-8">{children}</div>
        {footer && <div className="mt-8">{footer}</div>}
      </div>
    </div>
  </div>
);

/* Brand-styled input */
export const IDField = ({ label, ...props }) => (
  <label className="block">
    <span className="id-sans text-[12px] font-medium uppercase tracking-[0.14em] text-[var(--id-charcoal)]/60">{label}</span>
    <input
      {...props}
      className="id-sans mt-2 w-full rounded-xl border border-[var(--id-mist)] bg-white px-4 py-3 text-[15px] text-[var(--id-charcoal)] outline-none transition-colors placeholder:text-[var(--id-charcoal)]/35 focus:border-[var(--id-gold)] focus:ring-2 focus:ring-[var(--id-gold)]/20"
    />
  </label>
);
